import type { FC } from 'react';

import { cn } from '@repo/utils/common';

import { LocaleLink } from '@/components/common/LocaleLink';
import { SIPLogo } from '@/components/common/SIPLogo';

interface SIPLogoLinkProps {
  className?: string;
  logoClassName?: string;
}

/**
 * Rendered logo size, defined once here rather than per call site, so the live
 * Header, the static ToolbarFallback and the Footer render the same logo by
 * default. The ramp mirrors the SIP Partner Portal's header lockup exactly so
 * the two apps read as one brand when a user moves between them; change it
 * there and here together. The Footer has no bar and inherits the size
 * deliberately.
 */
const LOGO_SIZE_CLASS = 'h-5 w-auto sm:h-6 md:h-7';

export const SIPLogoLink: FC<SIPLogoLinkProps> = ({ className, logoClassName }) => {
  return (
    <LocaleLink
      to="/"
      aria-label="SIP Konfigurator"
      title="SIP Konfigurator"
      className={cn(
        // `p-1` is the focus ring's breathing room, not spare padding — keep it.
        'text-primary flex cursor-pointer items-center justify-center rounded-md p-1',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        className,
      )}
    >
      <SIPLogo className={cn(LOGO_SIZE_CLASS, logoClassName)} />
    </LocaleLink>
  );
};
